module.exports = __webpack_public_path__ + "assets/img/calender.a2a19809.svg";